const manifest =
  typeof window['__manifest__'] === 'object' ? window['__manifest__'] : {};

export default {
  lookup(name) {
    if (typeof manifest[name] === 'undefined') {
      return name;
    }
    return manifest[name];
  },
};
